import {EventEmitter, Injectable} from '@angular/core';
import {NationalTeamsService} from './national-teams.service';
import {EventService} from './event.service';
import { Router} from "@angular/router";

@Injectable()
export class FundraisingViewService {

    public onViewInit: EventEmitter<any> = new EventEmitter();

    constructor(
        private router: Router,
        private nationalTeamsService: NationalTeamsService,
        private eventService: EventService
    ) {}

    canManageNationalTeamsAndEventsView() {
        return this.canManageEvents() && this.canManageNationalTeams();
    }

    canManageNationalTeams() {
        return this.listNotEmpty(this.nationalTeamsService.getAllNationalTeams());
    }

    canManageEvents() {
        return this.listNotEmpty(this.eventService.events) || this.listNotEmpty(this.eventService.pastEvents);
    }

    switchView() {
        if (this.isManageNationalTeamsViewVisible()) {
            this.router.navigate(['/home']);
            localStorage.setItem('org.lls.last-view', 'events');
        } else if (this.isManageEventsViewVisible()) {
            this.router.navigate(['/national/teams/' + this.nationalTeamsService.selectedNationalTeam.teamId]);
            localStorage.setItem('org.lls.last-view', 'national-teams');
        }
    }

    switchToCurrentView(newView) {
        if (newView === 'events_view') {
            this.router.navigate(['/home']);
            localStorage.setItem('org.lls.last-view', 'events');
        } else if (newView === 'national_teams_view') {
            this.router.navigate(['/national/teams/' + this.nationalTeamsService.selectedNationalTeam.teamId]);
            localStorage.setItem('org.lls.last-view', 'national-teams');
        }
    }

    isManageNationalTeamsViewVisible() {
        return localStorage.getItem('org.lls.last-view') === 'national-teams' && this.canManageNationalTeams();
    }

    isManageEventsViewVisible() {
        return localStorage.getItem('org.lls.last-view') === 'events' && this.canManageEvents();
    }

    getCurrentViewLabel() {
        if (this.isManageEventsViewVisible()) {
            return 'Manage National Team';
        } else {
            return 'Manage My Events';
        }
    }

    getCurrentView() {
        if (this.isManageEventsViewVisible()) {
            return 'events_view';
        } else {
            return 'national_teams_view';
        }
    }

    isNationalTeamView() {
        return this.getCurrentView() === 'national_teams_view';
    }

    private listNotEmpty(list) {
        return !!list && list.length > 0;
    }
}
